import {parseId} from 'core/common/utils/utils';
import GridConfig from "core/grid/domain/gridConfig";
import {observable} from "mobx";
import {DomainAncestor} from "core/common/domain/DomainAncestor";
import MdField, {FIELDTYPE} from "core/metamodel/mdField";

export enum SORTORDER {
  ASC = 'ASC',
  DESC = 'DESC'
}


export default class GridConfigSort extends DomainAncestor {


  public $gridConfigRef: GridConfig;

  @observable  field: MdField;


  @observable public fixed: boolean;

  @observable public sortOrder: SORTORDER;


  constructor (gridConfig: GridConfig, json: any) {
    super(json);
    this.$gridConfigRef = gridConfig;
    if (this.field) this.field = (gridConfig && this.field.fieldType !== FIELDTYPE.SQLRESULT) ? gridConfig.getEntityRef().getField(this.field.fieldName) : new MdField(this.field);
  }

  get fieldKey() {
    return (this.field) ? this.field.fieldKey : undefined;
  }

  getFieldName() {
    return (this.field) ? this.field.fieldName : undefined;
  }

}



// WEBPACK FOOTER //
// ./src/core/grid/domain/gridConfigSort.ts